import React from 'react';
import styled from 'styled-components';
import logo from './img/sidebar/CINJ.svg';
import bgGraphic from './img/bg-graphic.png';
import VideoCard from './components/VideoCard.js'


const MainHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%; 
  height: 90%; 
  background-image: url(${bgGraphic});
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
    div.content{
        padding: 120px 0px 108px 120px; 
        max-width: 560px; 
        @media (max-width: 900px){
            padding: 160px 0px 60px 80px; 
        }
        @media (max-width: 400px){
            max-width: 280px; 
        }
    }
  h1{
    font-size: 32px;
    margin-bottom: 20px;
  }
  p{
    font-weight-bold;
  }
  @media (max-width: 990px){
    background-image: none;
}
`;

const Icon = styled.img`
  color: #377879;
  width: 120px; 
  height: auto;
`
const Information = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 100px auto; 
  div{
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    align-items: center;
    margin: 0px 40px; 
    h2{
      margin-top: 18px;
      text-align: center;
    }
    p{
      max-width: 300px;
    }
  }
  @media (max-width: 768px){
      flex-direction column;
  }
`

const StyledVideoRow = styled.div`
    margin: 0px 0px;
    display: flex; 
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%; 
    // background-color:#97B4B4; 
    padding: 40px 20px;
    div{
        margin:0px 20px 20px 20px; 
    }
    @media (max-width: 900px){
        flex-direction column;
    }
 `

 const StyledGetStarted = styled.button`
    width: fit-content; 
    padding: 12px 24px; 
    border-radius: 6px; 
    background-color: #377879;
    color: #fff; 
    font-weight: bold;
 `

 class VideoRow extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        items: [
            {
                img: require( './img/videos/DrStrair.png'),
                name: 'Dr.Strair',
                label: '(Doctor)',
                desc: 'Dr. Strair explains the purpose of this site and how to get the most out of it.',
                key: 1
            },
            {
                img: require('./img/videos/Tom.png'),
                name: 'Tom',
                label: '(Patient)',
                desc: 'Tom describes a conversation he had with another patient when making his decision.',
                key: 2
            },
            {
                img: require( './img/videos/Kimi.png'),
                name: 'Kimi',
                label: '(Patient)',
                desc: 'Kimi talks about having to ask her relatives to live with her during her recovery.',
                key: 3
            },
        ]
    };
  }

  render(){
    const { items } = this.state;
    return (
        <StyledVideoRow>
            {
                items.map((item) => {
                    return (
                        <VideoCard className = 'StyledVideoCard'
                        img={item.img}
                        name={item.name} 
                        label={item.label}
                        desc={item.desc}
                        key={item.key}>
                        </VideoCard>
                    )
                })
            }
        </StyledVideoRow>
    )
}
}

class HomeContent extends React.Component {
    constructor(props){
        super(props)
        this.infoRef = React.createRef();
    }

    handleOnClick = (event) => {

        if(this.infoRef.current){
            this.infoRef.current.scrollIntoView({ 
                behavior: "smooth", 
                block: "nearest"
            })
        }
    }

    render(){
        return(
            <div className="container-fluid">
                <MainHeader>
                    <div className="content">
                    <h1>Welcome to your Stem Cell Transplant Support Tool</h1>
                    <p>We know stem cell transplant can be an overwhelming experience. We are here to help!</p>
                    <p>We will provide you with emotional support, information, and personalized data to get you prepared and help you understand the process.</p>
                    <StyledGetStarted onClick={this.handleOnClick}>Learn more</StyledGetStarted>
                    </div>
                </MainHeader>  
                <div ref={this.infoRef}>     
                    <Information>
                        <div>
                            <Icon src= {require( './img/calendar.png')}/>
                            {/* <Icon className='fas fa-calendar-day fa-5x'></Icon> */}
                            <h2>First 100 Days</h2>
                            <p>A timeline of what you may experience during the first 100 days of the stem cell transplant process</p>
                        </div>
                        <div>
                            <Icon src= {require( './img/laptop.png')}/>
                            {/* <Icon className='fas fa-hand-holding-heart fa-5x'></Icon> */}
                            <h2>Care</h2>
                            <p>Check out some tips to get you and your caregivers prepared to care for someone who is going through stem cell transplant process</p>
                        </div>
                        <div>
                            <Icon src= {require( './img/Graph.png')}/>
                            {/* <Icon className='fas fa-chart-line fa-5x'></Icon> */}
                            <h2>Prognosis Data</h2>
                            <p>Check your stem cell transplant survival rates based on your medical information provided by the Cancer Institute of New Jersey</p>
                        </div>
                    </Information>
                    <h2 style={{paddingLeft: 40 + 'px'}}>Videos to Get You Started</h2>
                    <VideoRow/> 
                </div>
            </div>
        )
    }
}


export const Home = (props) => (
  <HomeContent/>
)